import axios from 'axios';
import { getToken, removeToken } from '../utils/jwtUtils';

// Use environment variable for API URL (set in Vercel dashboard for production)
export const getBaseURL = () => {
  // REACT_APP_API_URL should be set to:
  // - Development: http://localhost:3001 (or omit to use default)
  // - Production: https://mathwiz-league-api.fly.dev
  return process.env.REACT_APP_API_URL || 'http://localhost:3001';
};

const baseURL = getBaseURL();

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false, // Not needed for JWT in Authorization header
});

// Add a request interceptor for JWT token
apiClient.interceptors.request.use(
  request => {
    // Add JWT token to Authorization header if available and valid
    const token = getToken();
    
    if (token) {
      try {
        // Set the Authorization header
        request.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Error processing token:', error);
        request.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return request;
  },
  error => Promise.reject(error)
);

// Add response interceptor for handling authentication errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle 401 Unauthorized errors
    if (error.response?.status === 401) {
      // Clear token data
      removeToken();
      
      // Add custom error information
      error.isAuthError = true;
      error.authErrorMessage = 'Your session has expired. Please log in again.';
      
      // We will not automatically redirect here - let the component handle redirection
      // This avoids unexpected redirects in the middle of operations
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;